import { splitLinks } from './linkify';

// Mirrors backend domain.MaxAttachments; the backend is the real
// enforcement, this is faster feedback only.
export const MAX_MESSAGE_ATTACHMENTS = 4;

export function canAddAttachment(currentCount: number): boolean {
  return currentCount < MAX_MESSAGE_ATTACHMENTS;
}

// A message or reply may be a photo alone, but never nothing (the backend
// enforces the same rule; this is the composer's faster feedback).
export function hasSendableContent(text: string, photoCount: number): boolean {
  return text.trim() !== '' || photoCount > 0;
}

export type AttachmentInput = { kind: 'image'; photoBlobId: string } | { kind: 'link'; url: string };

// The request's attachments: the photos, then -- when `text` is given and
// there is room under the cap -- the first link in it. The server builds the
// preview (and may build none); the URL it is sent must be a visible token
// of the same text, which the link splitter guarantees.
export function toAttachmentInputs(photoBlobIds: string[], text?: string): AttachmentInput[] {
  const inputs: AttachmentInput[] = photoBlobIds.map((photoBlobId) => ({ kind: 'image', photoBlobId }));

  if (text && inputs.length < MAX_MESSAGE_ATTACHMENTS) {
    const firstLink = splitLinks(text).find((segment) => segment.type === 'link');

    if (firstLink) inputs.push({ kind: 'link', url: firstLink.value });
  }

  return inputs;
}
